export default "__VITE_ASSET__DRgLXcKg__"